import { useState, useEffect } from 'react';

// TODO Cover with unit tests, it's really needed, come on! :)
// Useful to reduce amount of re-renders of component that depends on rapidly changed value. Use this
// hook to throttle this value in parent component and pass it to target memoized component by prop.
// Good example of this hook usage is while speed-scrolling, top-shelf card in EPG should be updated
// with certain delay after scroll button was released.
export function useDebounceValue<Value>(value: Value, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
